import React from 'react';

export default function LogModal({ open, logs, onClose }) {
  if (!open) return null;
  return (
    <>
      <div className="log-modal-overlay" />
      <div className="log-modal">
        <strong>Generating progress</strong>
        <pre className="log-modal-content">{logs}</pre>
        <button className="log-modal-close" onClick={onClose} aria-label="Close log">&times;</button>
      </div>
    </>
  );
}
